module.exports = __webpack_public_path__ + "img/huawei-p20-pro.81203bb4.jpg";